/*
  accordion
*/
/**
 * Cookies logic
 */

/************************************************
	Cookie Banner (WL ONLY)
*************************************************/
jQuery(document).ready(function ($) {
    if ($(window).width() < 768) {

        $('*[data-toggle="collapse"]').each(function () {
            var objectID = $(this).attr('data-target');
            $(objectID).hide();
            $(this).attr('aria-expanded', 'false');
        });

    }

    //hide/show content on click
    $('*[data-toggle="collapse"]').on('click', function () {

        var objectID = $(this).attr('data-target');
        var expanded = $(this).attr('aria-expanded');
        if (expanded == "true") {
            $(objectID).hide();
            $(this).attr('aria-expanded', 'false');
            $(this).children(".parent").addClass("img-icon_mob_1");
            $(this).children(".parent").removeClass("img-icon_mob_4");
        }
        else { $(objectID).show(); $(this).attr('aria-expanded', 'true'); $(this).children(".parent").addClass("img-icon_mob_4"); $(this).children(".parent").removeClass("img-icon_mob_1"); }

    });


});
